import React, { useState, memo } from "react";
import PropTypes from "prop-types";
import Axios from "./../../axios";
import {
  Menu,
  MenuItem,
  Highlighter,
  Typeahead,
} from "react-bootstrap-typeahead";
//#region Slice Imports
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTask } from "./../../Slices/sessionSlice";
//#endregion

// needs to be extracted from sessionSlice
const candidate = "61dc087d2625b634c8aae6a5";

function TaskSearch() {
  //#region state
  const [state, setState] = useState({
    loading: false,
    tasks: [],
    query: "",
  });
  //#endregion

  //#region Selector
  const { selectedTask, sessionUser } = useSelector(
    (state) => state.sessionSlice
  );
  const dispatch = useDispatch();
  //#endregion

  const onChangeSearch = (selected) => {
    dispatch(setSelectedTask(selected));
  };

  const onSearch = (queryValue) => {
    setState({ ...state, loading: true });
    Axios.get(
      `/api/candidate/search-tasks?query=${queryValue}&&user=${sessionUser._id}`
    )
      .then((res) => {
        //destructure data
        const { results } = res.data;
        console.log(`search results ${queryValue} :- `, results);
        setState({
          ...state,
          tasks: results,
          loading: false,
          query: queryValue,
        });
        // setTasks(results);
        // setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  const filterByCallback = (option, props) => {
    const filterResult = [
      option.name,
      option.project.name,
      option.project.client.name,
    ].some((element) => element.toLowerCase().includes(props.text));
    return filterResult;
  };

  const RenderMenu = (results, menuProps) => {
    console.log("render menu results :- ", results);
    if (results.results) {
      return (
        <Menu {...menuProps} id={"menu"}>
          {results.results.map((result, idx) => {
            const { name, customOption } = result;
            if (customOption && results.results.length === 1) {
              return (
                <MenuItem
                  key={Math.random()}
                  option={result}
                  position={idx}
                  id={idx}
                >
                  {`Add Task : ${name}`}
                </MenuItem>
              );
            }
            if (customOption) {
              return <></>;
            }
            const {
              project: {
                name: projectProp,
                supervisingClient: { name: clientProp },
              },
            } = result;
            return (
              <MenuItem
                key={Math.random()}
                option={result}
                position={idx}
                id={idx}
              >
                <Highlighter search={state.query}>
                  {`${name} > ${projectProp} > ${clientProp}`}
                </Highlighter>
              </MenuItem>
            );
          })}
        </Menu>
      );
    }

    return <Menu />;
  };

  return (
    <div>
      <Typeahead
        id="task_search"
        isLoading={state.loading}
        labelKey="name"
        options={state.tasks}
        placeholder="search tasks... "
        selected={selectedTask}
        onChange={onChangeSearch}
        minLength={1}
        onInputChange={onSearch}
        allowNew={true}
        filterBy={() => true}
        size="lg"
        useCache={true}
        renderMenuItemChildren={(option, props, idx) => {
          const taskName = option.name;
          const projectName = option.project.name;
          const clientName = option.project.supervisingClient.name;
          return (
            <>
              <span>
                <Highlighter search={state.query}>
                  {`${taskName} > ${projectName} > ${clientName}`}
                </Highlighter>
              </span>
            </>
          );
        }}
      />
    </div>
  );
}

export default TaskSearch;
